import React from 'react'
import SectionTitle from './SectionTitle'

interface PartnershipProps {
    name: string
    status: string
    children: React.ReactNode
}

function Partnership({name, status, children}: PartnershipProps) {
    return (
        <div className="print-avoid-break relative rounded-sm border border-line bg-panel px-4 pb-4 pt-6 transition-colors duration-150 hover:border-accent w-full md:flex-1 min-w-0">
            <h3 className="pointer-events-none absolute -top-2 left-3 bg-panel px-2 font-display text-[11px] font-bold uppercase leading-4 tracking-[.22em] text-accent">
                {name}
            </h3>
            <p className="font-mono text-[10px] uppercase tracking-[.2em] text-primary">
                {status}
            </p>
            <p className="mt-2 text-sm font-medium text-body leading-relaxed">
                {children}
            </p>
        </div>
    )
}

export default function Partnerships() {
    return (
        <section>
            <SectionTitle title="Partnerships" index="03" />
            <div className="mt-8 flex flex-col md:flex-row gap-4">
                <Partnership name="Windmill" status="Official Partner">
                    Partner status earned through production platform work—Betabit designs, builds, and operates Windmill-based data platforms for clients.
                </Partnership>
                <Partnership name="Tailscale" status="Official Reseller">
                    Betabit resells and operates Tailscale deployments end to end, including full client network layers.
                </Partnership>
            </div>
        </section>
    )
}
